// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wp-card {
  display: flex;
  align-items: stretch;
  background: var(--ion-card-background);
  border-radius: 4px;
  margin: 2px 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow 0.15s;
}
.wp-card:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
}

.wp-color-bar {
  width: 4px;
  flex: 0 0 4px;
  background: var(--ion-color-medium);
}

:host-context(.departure-wp) .wp-color-bar {
  background: rgb(255, 89, 94);
}

:host-context(.mission-wp) .wp-color-bar {
  background: rgb(138, 201, 38);
}

:host-context(.arrival-wp) .wp-color-bar {
  background: rgb(50, 108, 235);
}

.wp-card-content {
  flex: 1;
  min-width: 0;
  padding: 3px 5px;
}

.wp-header-row {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 2px;
}

.wp-type-icon {
  font-size: 13px;
  color: var(--ion-color-medium);
  flex: 0 0 auto;
}

.wp-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--ion-color-dark);
  line-height: 1;
}

.wp-params-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3px;
}

.wp-field {
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: rgba(var(--ion-text-color-rgb), 0.04);
  border: 1px solid rgba(var(--ion-text-color-rgb), 0.09);
  border-radius: 4px;
  padding: 2px 4px 2px;
}

.wp-field-label {
  font-size: 8px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--ion-color-medium);
  line-height: 1;
}

.wp-field-input {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  height: 14px;
  padding: 0;
  color: var(--ion-text-color);
  -moz-appearance: textfield;
}
.wp-field-input::-webkit-inner-spin-button, .wp-field-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.wp-delete-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  flex: 0 0 20px;
  background: rgba(var(--ion-color-danger-rgb), 0.08);
  border-left: 1px solid rgba(var(--ion-color-danger-rgb), 0.2);
  cursor: pointer;
  transition: background 0.15s;
}
.wp-delete-bar ion-icon {
  font-size: 13px;
  color: var(--ion-color-danger);
}
.wp-delete-bar:hover {
  background: rgba(var(--ion-color-danger-rgb), 0.25);
}

/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or smaller than 550px high */
@media (max-width: 599px) {
  .wp-delete-bar {
    width: 18px;
    flex: 0 0 18px;
  }
  .wp-delete-bar ion-icon {
    font-size: 11px;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min-width of 800px and min-height of 550px */
@media (min-width: 600px) and (max-width: 1023px) {
  .wp-card-content {
    padding: 4px 6px;
  }
  .wp-header-row {
    margin-bottom: 3px;
  }
  .wp-label {
    font-size: 13px;
  }
  .wp-type-icon {
    font-size: 14px;
  }
  .wp-field {
    padding: 3px 5px;
  }
  .wp-field-input {
    height: 16px;
    font-size: 12px;
  }
  .wp-delete-bar {
    width: 22px;
    flex: 0 0 22px;
  }
  .wp-delete-bar ion-icon {
    font-size: 14px;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1024px) {
  .wp-card-content {
    padding: 5px 7px;
  }
  .wp-header-row {
    margin-bottom: 4px;
  }
  .wp-label {
    font-size: 14px;
  }
  .wp-type-icon {
    font-size: 16px;
  }
  .wp-field {
    padding: 4px 6px;
  }
  .wp-field-label {
    font-size: 9px;
  }
  .wp-field-input {
    height: 18px;
    font-size: 13px;
  }
  .wp-delete-bar {
    width: 26px;
    flex: 0 0 26px;
  }
  .wp-delete-bar ion-icon {
    font-size: 16px;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/components/trajectory-creation/waypoint-item-tree/waypoint-item-tree.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oBAAA;EACA,sCAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;AACF;AACE;EACE,yCAAA;AACJ;;AAGA;EACE,UAAA;EACA,aAAA;EACA,mCAAA;AAAF;;AAGA;EACE,4BAAA;AAAF;;AAEA;EACE,6BAAA;AACF;;AACA;EACE,6BAAA;AAEF;;AACA;EACE,OAAA;EACA,YAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAEF;;AACA;EACE,eAAA;EACA,8BAAA;EACA,cAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iDAAA;EACA,uDAAA;EACA,kBAAA;EACA,oBAAA;AAEF;;AACA;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,cAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,4BAAA;EACA,0BAAA;AAEF;AAAE;EAEE,wBAAA;EACA,SAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;EACA,mDAAA;EACA,6DAAA;EACA,eAAA;EACA,4BAAA;AAAF;AAEE;EACE,eAAA;EACA,8BAAA;AAAJ;AAGE;EACE,mDAAA;AADJ;;AAMA,wBAAA;AAEA,0EAAA;AACA;EACE;IACE,WAAA;IACA,cAAA;EAJF;EAME;IAAW,eAAA;EAHb;AACF;AAMA,2BAAA;AAEA,yBAAA;AAEA,8EAAA;AACA;EACE;IAAmB,gBAAA;EALnB;EAMA;IAAiB,kBAAA;EAHjB;EAIA;IAAY,eAAA;EADZ;EAEA;IAAgB,eAAA;EAChB;EACA;IAAY,gBAAA;EAEZ;EADA;IACE,YAAA;IACA,eAAA;EAGF;EAAA;IACE,WAAA;IACA,cAAA;EAEF;EAAE;IAAW,eAAA;EAGb;AACF;AAAA,4BAAA;AAEA,yBAAA;AAEA,8DAAA;AACA;EACE;IAAmB,gBAAA;EACnB;EAAA;IAAiB,kBAAA;EAGjB;EAFA;IAAY,eAAA;EAKZ;EAJA;IAAgB,eAAA;EAOhB;EALA;IAAY,gBAAA;EAQZ;EAPA;IAAkB,cAAA;EAUlB;EATA;IACE,YAAA;IACA,eAAA;EAWF;EARA;IACE,WAAA;IACA,cAAA;EAUF;EARE;IAAW,eAAA;EAWb;AACF;AARA,4BAAA","sourcesContent":[".wp-card {\r\n  display: flex;\r\n  align-items: stretch;\r\n  background: var(--ion-card-background);\r\n  border-radius: 4px;\r\n  margin: 2px 4px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  overflow: hidden;\r\n  cursor: pointer;\r\n  transition: box-shadow 0.15s;\r\n\r\n  &:hover {\r\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);\r\n  }\r\n}\r\n\r\n.wp-color-bar {\r\n  width: 4px;\r\n  flex: 0 0 4px;\r\n  background: var(--ion-color-medium);\r\n}\r\n\r\n:host-context(.departure-wp) .wp-color-bar {\r\n  background: rgb(255, 89, 94);\r\n}\r\n:host-context(.mission-wp) .wp-color-bar {\r\n  background: rgb(138, 201, 38);\r\n}\r\n:host-context(.arrival-wp) .wp-color-bar {\r\n  background: rgb(50, 108, 235);\r\n}\r\n\r\n.wp-card-content {\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 3px 5px;\r\n}\r\n\r\n.wp-header-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.wp-type-icon {\r\n  font-size: 13px;\r\n  color: var(--ion-color-medium);\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.wp-label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: var(--ion-color-dark);\r\n  line-height: 1;\r\n}\r\n\r\n.wp-params-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 3px;\r\n}\r\n\r\n.wp-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  background: rgba(var(--ion-text-color-rgb), 0.04);\r\n  border: 1px solid rgba(var(--ion-text-color-rgb), 0.09);\r\n  border-radius: 4px;\r\n  padding: 2px 4px 2px;\r\n}\r\n\r\n.wp-field-label {\r\n  font-size: 8px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: var(--ion-color-medium);\r\n  line-height: 1;\r\n}\r\n\r\n.wp-field-input {\r\n  width: 100%;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  line-height: 1;\r\n  height: 14px;\r\n  padding: 0;\r\n  color: var(--ion-text-color);\r\n  -moz-appearance: textfield;\r\n\r\n  &::-webkit-inner-spin-button,\r\n  &::-webkit-outer-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n.wp-delete-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 20px;\r\n  flex: 0 0 20px;\r\n  background: rgba(var(--ion-color-danger-rgb), 0.08);\r\n  border-left: 1px solid rgba(var(--ion-color-danger-rgb), 0.2);\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n\r\n  ion-icon {\r\n    font-size: 13px;\r\n    color: var(--ion-color-danger);\r\n  }\r\n\r\n  &:hover {\r\n    background: rgba(var(--ion-color-danger-rgb), 0.25);\r\n  }\r\n}\r\n\r\n\r\n/*#region Small Screens*/\r\n\r\n/* Styles for screens smaller than 800px wide or smaller than 550px high */\r\n@media (max-width: 599px) {\r\n  .wp-delete-bar {\r\n    width: 18px;\r\n    flex: 0 0 18px;\r\n\r\n    ion-icon { font-size: 11px; }\r\n  }\r\n}\r\n\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n\r\n/* Styles for medium screens with min-width of 800px and min-height of 550px */\r\n@media (min-width: 600px) and (max-width: 1023px) {\r\n  .wp-card-content { padding: 4px 6px; }\r\n  .wp-header-row { margin-bottom: 3px; }\r\n  .wp-label { font-size: 13px; }\r\n  .wp-type-icon { font-size: 14px; }\r\n\r\n  .wp-field { padding: 3px 5px; }\r\n  .wp-field-input {\r\n    height: 16px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .wp-delete-bar {\r\n    width: 22px;\r\n    flex: 0 0 22px;\r\n\r\n    ion-icon { font-size: 14px; }\r\n  }\r\n}\r\n\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n\r\n/* Styles for screens larger than 1000px wide and 600px high */\r\n@media (min-width: 1024px) {\r\n  .wp-card-content { padding: 5px 7px; }\r\n  .wp-header-row { margin-bottom: 4px; }\r\n  .wp-label { font-size: 14px; }\r\n  .wp-type-icon { font-size: 16px; }\r\n\r\n  .wp-field { padding: 4px 6px; }\r\n  .wp-field-label { font-size: 9px; }\r\n  .wp-field-input {\r\n    height: 18px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .wp-delete-bar {\r\n    width: 26px;\r\n    flex: 0 0 26px;\r\n\r\n    ion-icon { font-size: 16px; }\r\n  }\r\n}\r\n\r\n/*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
